import { render, staticRenderFns } from "./AmoCRM.vue?vue&type=template&id=32735880&scoped=true&"
import script from "./AmoCRM.vue?vue&type=script&lang=ts&"
export * from "./AmoCRM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32735880",
  null
  
)

export default component.exports